import React from 'react';

const LoadingSpinner = ({
    size = 'md',
    className = '',
    message = 'Loading...'
}) => {
    const sizeClasses = {
        sm: 'h-4 w-4',
        md: 'h-8 w-8',
        lg: 'h-12 w-12'
    };

    return (
        <div className={`flex flex-col items-center justify-center min-h-screen bg-gray-50 ${className}`}>
            <div className="flex flex-col items-center space-y-4">
                <div className={`animate-spin rounded-full border-4 border-gray-200 border-t-primary-600 ${sizeClasses[size]}`}></div>
                {message && (
                    <p className="text-sm text-gray-600 font-medium">{message}</p>
                )}
            </div>
        </div>
    );
};

export default LoadingSpinner
